import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import Stack from "@mui/material/Stack";
import TablePagination from "@mui/material/TablePagination";
import Typography from "@mui/material/Typography";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import dayjs from "dayjs";
import TablePaginationActions from "../../shared/components/Table/Actions";
import { dateTimeFormat } from "../../util/DateUtil";

export const getPrazoStatus = (tarefa) => {
  if (tarefa.finalizado) return { label: "Finalizada", color: "success" };
  if (!tarefa.possuiPrazo || !tarefa.dataHoraPrazo) return null;
  if (dayjs(tarefa.dataHoraPrazo).isBefore(dayjs())) {
    return { label: `Atrasada · ${dateTimeFormat(tarefa.dataHoraPrazo)}`, color: "error" };
  }
  return { label: `Prazo ${dateTimeFormat(tarefa.dataHoraPrazo)}`, color: "warning" };
};

const TarefaList = ({ tarefas, handleChangePage, setTarefa, atribuidasParaMim }) => {
  if (tarefas.content.length === 0) {
    return (
      <Box textAlign="center" color="text.secondary" py={5}>
        <TaskAltOutlinedIcon fontSize="large" />
        <Typography variant="body2" mt={1}>
          Nenhuma tarefa encontrada.
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <List disablePadding sx={{ border: 1, borderColor: "divider", borderRadius: 2, overflow: "hidden" }}>
        {tarefas.content.map((tarefa) => {
          const status = getPrazoStatus(tarefa);
          const pessoa = atribuidasParaMim ? tarefa.usuarioPor : tarefa.usuarioPara;
          return (
            <ListItemButton key={tarefa.codigo} divider onClick={() => setTarefa(tarefa)} sx={{ py: 1.5 }}>
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={1}
                alignItems={{ sm: "center" }}
                width="100%"
                minWidth={0}
              >
                <Box flexGrow={1} minWidth={0}>
                  <Typography
                    variant="body2"
                    fontWeight={500}
                    sx={{
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textDecoration: tarefa.finalizado ? "line-through" : undefined,
                      color: tarefa.finalizado ? "text.secondary" : "text.primary",
                    }}
                  >
                    {tarefa.descricao}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {atribuidasParaMim ? "Por" : "Para"} {pessoa?.nome ?? "--"}
                    {tarefa.dataHora && ` · ${dateTimeFormat(tarefa.dataHora)}`}
                  </Typography>
                </Box>
                {status && (
                  <Chip
                    size="small"
                    variant="outlined"
                    color={status.color}
                    label={status.label}
                    sx={{ alignSelf: { xs: "flex-start", sm: "center" } }}
                  />
                )}
              </Stack>
            </ListItemButton>
          );
        })}
      </List>
      <TablePagination
        rowsPerPageOptions={[]}
        rowsPerPage={tarefas.size || 0}
        component="div"
        count={tarefas.totalElements}
        page={tarefas.number}
        onPageChange={handleChangePage}
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? `${count} registros` : `mais de ${to}`}`
        }
        ActionsComponent={TablePaginationActions}
      />
    </Box>
  );
};

export default TarefaList;
